import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String }

  connect() {
    this.ready = false
    this.pending = new Map()
    window.setTimeout(() => { this.ready = true }, 0)
  }

  disconnect() {
    this.pending.forEach((timer) => window.clearTimeout(timer))
  }

  persist(event) {
    if (!this.ready || this.reverting) return

    const disclosure = event.currentTarget
    const key = disclosure.dataset.disclosureKey
    if (!key) return

    window.clearTimeout(this.pending.get(key))
    this.pending.set(key, window.setTimeout(() => this.save(disclosure, key), 180))
  }

  async save(disclosure, key) {
    const collapsed = !disclosure.open

    try {
      const response = await fetch(this.urlValue, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content || "",
          "Accept": "application/json"
        },
        body: JSON.stringify({ disclosure: { key, collapsed } }),
        credentials: "same-origin"
      })
      if (!response.ok) throw new Error("Could not save disclosure state")
    } catch (_error) {
      this.reverting = true
      disclosure.open = collapsed
      this.reverting = false
    } finally {
      this.pending.delete(key)
    }
  }
}
